<!--
    BD Handover Configuration — Wave 3
    SB konfiguriert eine Inkasso-Übergabe BEVOR sie zur Freigabe eingereicht wird.
    @ticket TM-1000001786
-->
@if (initialized) {
    <div class="flex flex-column gap-3">

        <!-- Header -->
        <div class="flex align-items-center gap-2">
            <i class="fa-light fa-file-arrow-up text-primary"></i>
            <span class="font-semibold text-lg">Inkasso-Übergabe konfigurieren</span>
        </div>

        <!-- Error -->
        @if (errorMessage) {
            <p-message severity="error" [text]="errorMessage" styleClass="w-full"></p-message>
        }

        <!-- Success -->
        @if (success) {
            <p-message severity="success"
                       text="Übergabe wurde zur Genehmigung eingereicht."
                       styleClass="w-full"></p-message>
        }

        <!-- Form -->
        @if (!success) {
            <div class="surface-card border-round p-3 flex flex-column gap-3">

                <!-- Contract selection -->
                <div>
                    <label class="block text-sm font-medium mb-1">
                        Vertrag <span class="text-red-500">*</span>
                    </label>
                    @if (contractOptions.length === 0) {
                        <div class="text-sm text-600">
                            Keine Verträge zur Übergabe verfügbar.
                        </div>
                    } @else {
                        <p-select [options]="contractOptions"
                                  optionLabel="label"
                                  optionValue="value"
                                  [(ngModel)]="selectedContractId"
                                  placeholder="Vertrag auswählen…"
                                  appendTo="body"
                                  styleClass="w-full">
                        </p-select>
                    }
                </div>

                <!-- TM-1000001933: OPTIONALES Stornogrund-Dropdown (area=INKASSO_HANDOVER).
                     Leere Auswahl = „Standardgrund verwenden" → Backend-Bereichs-Default. -->
                @if (hasStornoReasons) {
                    <div>
                        <label class="block text-sm font-medium mb-1">Stornogrund</label>
                        <p-select [options]="stornoReasons"
                                  optionLabel="name"
                                  optionValue="id"
                                  [(ngModel)]="selectedReasonTypeId"
                                  placeholder="Standardgrund verwenden"
                                  [showClear]="true"
                                  appendTo="body"
                                  styleClass="w-full">
                        </p-select>
                    </div>
                }

                <!-- Reason -->
                <div>
                    <label class="block text-sm font-medium mb-1">
                        Begründung <span class="text-red-500">*</span>
                    </label>
                    <textarea pInputTextarea
                              [(ngModel)]="reason"
                              rows="4"
                              placeholder="Bitte Begründung der Übergabe eingeben…"
                              class="w-full"></textarea>
                </div>

                <!-- Hint -->
                <p-message severity="info"
                           text="Nach dem Einreichen gibt ein Benutzer mit der Rolle „admin“, „bd_admin“ oder „bd_approver“ die Übergabe frei."
                           styleClass="w-full"></p-message>

                <!-- Submit -->
                <div class="flex justify-content-end">
                    <p-button label="Zur Genehmigung einreichen"
                              icon="fa-light fa-paper-plane"
                              [loading]="submitting"
                              [disabled]="contractOptions.length === 0"
                              (onClick)="submit()">
                    </p-button>
                </div>
            </div>
        }
    </div>
}
